import { z } from 'zod/v4';

import { unitsOfMeasurementSchema } from '../../../schemas/units-of-measurement.schema';
import { vehicleTypeSchema } from '../../../schemas/vehicle-type.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { activitiesSchema } from './activities.schema';
import { assetInvitationTypeSchema } from './asset-invitation-type.schema';
import { assetTypeSchema } from './asset-type.schema';
import { countryCodeSettingsSchema } from './country-code-settings.schema';
import { dataVersionSchema } from './data-version.schema';

export const companySettingsSchema = z.object({
  automaticInvitation: z.boolean(),
  allowTripCreationByDriver: z.boolean(),
  enableMapManagement: z.boolean(),
  shareDataAnonymously: z.boolean(),
  shareTripData: z.boolean(),
  allowSMS: z.boolean(),
  partnerIntegrationSync: z.boolean(),
  userType: assetTypeSchema,
  countryCodeSettings: countryCodeSettingsSchema,
  assetInvitationType: assetInvitationTypeSchema,
  numberOfWeeksToSaveData: z.number(),
  modifiedOn: coercedDate,
  activities: activitiesSchema,
  isFleetOnlyVersion: z.boolean().default(false),
  isFleetPortalEnabled: z.boolean(),
  isConfigurationProfileEnabled: z.boolean(),
  isRoutingProfileEnabled: z.boolean(),
  isSpeedCoachingEnabled: z.boolean(),
  displayDashboard: z.boolean(),
  isUnitConversionEnabled: z.boolean(),
  isVehicleGroupDefaultEnabled: z.boolean(),
  isMapsetsEnabled: z.boolean(),
  isFastestRoutingTypeEnabled: z.boolean(),
  allowedVehicleTypes: z.array(vehicleTypeSchema).nullable(),
  units: unitsOfMeasurementSchema,
  dataVersion: dataVersionSchema.nullable(),
  expirationDate: coercedDate.nullable(),
  companyName: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactName: z.string().nullable(),
  contactPhone: z.string().nullable(),
});

export type CompanySettings = z.infer<typeof companySettingsSchema>;
